(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedfeaturestabsblock = window.oneadvanced.refreshedfeaturestabsblock || {};
    window.oneadvanced.refreshedfeaturestabsblock.init = function () {
        console.log("initialising refreshedfeaturestabsblock...");
        var refreshedfeaturestabsblock = document.querySelectorAll('[data-features-block-id]');

        if (refreshedfeaturestabsblock.length) {
            for (var ftb = 0; ftb < refreshedfeaturestabsblock.length; ftb++) {
                featuresHandler(refreshedfeaturestabsblock[ftb].getAttribute('data-features-block-id'));
            }
        }

        /**
         * Handle the setup for each Features Tabs block on the page
         * @param {any} BlockId
         */
        function featuresHandler(BlockId) {
            var $ft_content = $('#features_tabs_content_' + BlockId);
            var $ft_titles = $('#features_tabs_titles_' + BlockId);
            var $elem = $('#features_tabs_' + BlockId);

            // set first tab content and title to is-active
            $ft_titles.find('li:first-child').addClass('is-active');
            $ft_content.find('div:first-child').addClass('is-active');

            // initiate Foundation tabs here rather than in the view
            let tabs = new Foundation.Tabs($elem, {
                deepLink: false,
                deepLinkSmudge: false,
                updateHistory: false
             });

            // store a reference to the initialised tab in a jQuery object
            // so that we can call public methods on it later
            window.oneadvanced.refreshedfeaturestabsblock.refreshedfeaturestabsblocks =
                window.oneadvanced.refreshedfeaturestabsblock.refreshedfeaturestabsblocks || {};
            window.oneadvanced.refreshedfeaturestabsblock.refreshedfeaturestabsblocks[`${BlockId}`] = $elem;

            // if mobile
            // add functionality to handle
            // tabstitles turning into a 'dropdown'
            if (Foundation.MediaQuery.is('medium down')) {
                makeIntoDropdown($elem);
            }
        }

        /**
         * Turns Foundation Tabs element into a dropdown on mobile
         * @param {any} $elem
         */
        function makeIntoDropdown($elem) {
            $elem.on('click', function (e) {
                $(e.target).closest('ul').toggleClass('expanded');
            });
        }
    };
    window.oneadvanced.refreshedfeaturestabsblock.hasLoaded = true;
})();